import { useContext } from 'react'

import dayjs from 'dayjs'
import { filter, join, size } from 'lodash'

import Button from 'Root/App/Button'
import { Context as UsageContext } from 'Root/App/Contexts/Usage'
import CoverImage from 'Root/App/CoverImage'
import Paragraph from 'Root/App/Paragraph'
import PreTitle from 'Root/App/PreTitle'
import List from 'Root/App/Tag/List'
import Title from 'Root/App/Title'
import RenderedHtml from 'Root/Component/RenderedHtml'
import 'dayjs/locale/it'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'

import PageLinkWrapper from '../../PageLinkWrapper'

const secondsToRelativeTime = (seconds?: number) => {
  if (!Boolean(seconds) || seconds <= 0) {
    return null
  }

  dayjs.extend(duration)
  dayjs.extend(relativeTime)

  return dayjs.duration(seconds, 'seconds').locale('it').humanize()
}

const Cover = ({ content, startCallback }) => {
  const useCase = useContext(UsageContext)

  const filtered = filter([
    content.label,
    `${!!content.basket ? content.basket : size(content.questions)} domande`,
    secondsToRelativeTime(content.timeLimit),
  ])

  return (
    <div className="flex flex-col gap-y-4">
      {Boolean(content.cover) && (
        <PageLinkWrapper slug={content.slug}>
          <CoverImage
            imageUrl={content.cover}
            dimensions={content.coverDimensions}
          />
        </PageLinkWrapper>
      )}
      <PageLinkWrapper slug={content.slug}>
        <PreTitle>{join(filtered, ' · ')}</PreTitle>
      </PageLinkWrapper>
      <PageLinkWrapper slug={content.slug}>
        <Title maxRows={3}>{content.title}</Title>
      </PageLinkWrapper>
      <Paragraph>{content.description}</Paragraph>
      {useCase !== 'card' && <RenderedHtml value={content.instructions} />}

      <List tags={content.tags} />

      {useCase !== 'card' && (
        <Button className="w-full" onClick={() => startCallback()} size="L">
          Inizia
        </Button>
      )}
    </div>
  )
}

export default Cover
